import React, { useEffect, useState } from "react";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { uniqBy } from "lodash";
import { useOfficeDoctor } from "repositories/patient-appointment-repository";

const pageNumber = 1;
function DoctorFilterList({ t, selectedOffice, setOfficeFilter, officeId }) {
  const [doctorOffices, setDoctorOffices] = useState([]);

  const { data, isLoading } = useOfficeDoctor(officeId, pageNumber, 100);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (pageNumber === 1) {
      if (!isLoading && data?.items) {
        setDoctorOffices(uniqBy([...data?.items], "id"));
      }
    } else if (!isLoading && data?.items) {
      setDoctorOffices((prev) => uniqBy([...prev, ...data?.items], "id"));
    }
  }, [isLoading, data]);

  useEffect(() => {
    if (selectedOffice?.length === doctorOffices?.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedOffice, doctorOffices]);

  const handleChange = (e, item) => {
    const offices = [...selectedOffice];
    const officeIndex = offices.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      offices.push(item.id);
    } else {
      if (officeIndex > -1) offices.splice(officeIndex, 1);
    }
    setOfficeFilter(offices);
    setSelectAll(false);
  };

  const handleAllChange = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setOfficeFilter(
        doctorOffices?.length ? doctorOffices?.map((item) => item.id) : []
      );
    } else {
      setOfficeFilter([]);
    }
  };

  return (
    <ul className={["filter-list"]}>
      {doctorOffices?.length && (
        <ul>
          <li>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={handleAllChange}
                  checked={selectAll}
                />{" "}
                <span>{t("waitingList.allDoctor")}</span>
              </label>
            </div>
          </li>
          <hr className="mr-4" />
        </ul>
      )}
      {doctorOffices?.length &&
        doctorOffices?.map((item, key) => (
          <li key={key}>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => handleChange(e, item)}
                  checked={selectedOffice?.includes(item.id)}
                />{" "}
                <span> {`${item.firstName} ${item.lastName}`}</span>
              </label>
            </div>
          </li>
        ))}
    </ul>
  );
}

export default DoctorFilterList;
